import React from 'react';

function Footer() {
  return (
    <footer className="bg-[#b7e9f7] py-4 w-full fixed bottom-0 border-2 border-[#1f7bbf]">
      <div className="container mx-auto text-center text-white w-3/4 md:w-full">
      <p className="text-black font-bold">
          &copy; 2025 Keep on Farming. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
